/** Returns values in first-seen order, dropping duplicates via Object.is. */
export function unique<T>(values: T[]): T[] {
  return values.filter(
    (value, index, list) =>
      list.findIndex((candidate) => Object.is(candidate, value)) === index
  );
}
